// ICAO info
import { includes } from "../utils/includes.js";
export const voiceCommCodes = ["H", "U", "V", "Y"];
export const satCommCodes = ["M1", "M2", "M3"];
export const acarsCodes = ["E1", "E2", "E3"];
export const datalinkCodes = [
    "J1",
    "J2",
    "J3",
    "J4",
    "J5",
    "J6",
    "J7",
];
export function isDatalinkCode(c) {
    return includes(datalinkCodes, c);
}
export const communicationCodes = [
    ...voiceCommCodes,
    ...satCommCodes,
    ...acarsCodes,
    ...datalinkCodes,
];
export function isVoiceCommCode(c) {
    return includes(voiceCommCodes, c);
}
export function isSatCommCode(c) {
    return includes(satCommCodes, c);
}
export function isACARSCode(c) {
    return includes(acarsCodes, c);
}
export function isCommunicationCode(c) {
    return isVoiceCommCode(c) || isSatCommCode(c) || isACARSCode(c) || isDatalinkCode(c);
}
export const approachCodes = ["A", "B", "K", "L", "S"];
export const otherNavigationCodes = [
    "N",
    "Z",
    "W",
    "D",
    "G",
    "T",
    "O",
    "F",
    "I",
    "R",
    "C",
    "X",
];
export const navigationCodes = [...approachCodes, ...otherNavigationCodes];
export function isApproachCode(c) {
    return includes(approachCodes, c);
}
export function isOtherNavigationCode(c) {
    return includes(otherNavigationCodes, c);
}
export function isNavigationCode(c) {
    return isApproachCode(c) || isOtherNavigationCode(c);
}
export const transponderCodes = [
    "N",
    "A",
    "C",
    "S",
    "P",
    "I",
    "X",
    "E",
    "H",
    "L",
];
export const adsbCodes = ["B1", "B2", "U1", "U2", "V1", "V2"];
export const adscCodes = ["D1", "G1"];
export const surveillanceCodes = [
    ...transponderCodes,
    ...adsbCodes,
    ...adscCodes,
];
export function isTransponderCode(c) {
    return includes(transponderCodes, c);
}
export function isAdsbCode(c) {
    return includes(adsbCodes, c);
}
export function isAdscCode(c) {
    return includes(adscCodes, c);
}
export function isSurveillanceCode(c) {
    return isTransponderCode(c) || isAdsbCode(c) || isAdscCode(c);
}
export const oceanicCodes = ["A1", "L1"];
export const rnav5Codes = ["B1", "B2", "B3", "B4", "B5"];
export const rnav2Codes = ["C1", "C2", "C4"];
export const rnav1Codes = ["D1", "D2", "D4"];
export const rnp1Codes = ["O1", "O2"];
export const rnpApproachCodes = ["S1", "S2"];
export const rnpArApproachCodes = ["T1"];
export const addnPbnCodes = ["Z1", "Z2", "Z5", "R1", "P1", "M1", "M2"];
export const pbnCodes = [
    ...oceanicCodes,
    ...rnav5Codes,
    ...rnav2Codes,
    ...rnav1Codes,
    ...rnpApproachCodes,
    ...rnpArApproachCodes,
    ...addnPbnCodes,
];
export function isOceanicCode(c) {
    return includes(oceanicCodes, c);
}
export function isRNAV5Code(c) {
    return includes(rnav5Codes, c);
}
export function isRNAV2Code(c) {
    return includes(rnav2Codes, c);
}
export function isRNAV1Code(c) {
    return includes(rnav1Codes, c);
}
export function isRNP1Code(c) {
    return includes(rnp1Codes, c);
}
export function isRNPApproachCode(c) {
    return includes(rnpApproachCodes, c);
}
export function isRNP_AR_ApproachCode(c) {
    return includes(rnpArApproachCodes, c);
}
export function isAddnPbnCode(c) {
    return includes(addnPbnCodes, c);
}
export function isPbnCode(c) {
    return (isOceanicCode(c) ||
        isRNAV1Code(c) ||
        isRNAV2Code(c) ||
        isRNAV5Code(c) ||
        isRNP1Code(c) ||
        isRNPApproachCode(c) ||
        isRNP_AR_ApproachCode(c) ||
        isAddnPbnCode(c));
}
export function extractCodes(str, codes) {
    const isValidInput = new RegExp(`^(${codes.join("|")})+$`).test(str);
    if (!isValidInput) {
        return null;
    }
    return codes.reduce((acc, code) => {
        const matches = str.match(new RegExp(code, "g"));
        acc.push(...(matches ?? []));
        return acc;
    }, []);
}
//# sourceMappingURL=equipment.js.map